import { render, staticRenderFns } from "./centreRight2Chart2.vue?vue&type=template&id=e6acc6a8&scoped=true&"
import script from "./centreRight2Chart2.vue?vue&type=script&lang=js&"
export * from "./centreRight2Chart2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6acc6a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6acc6a8')) {
      api.createRecord('e6acc6a8', component.options)
    } else {
      api.reload('e6acc6a8', component.options)
    }
    module.hot.accept("./centreRight2Chart2.vue?vue&type=template&id=e6acc6a8&scoped=true&", function () {
      api.rerender('e6acc6a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/components/chart/centreRight2/centreRight2Chart2.vue"
export default component.exports